import React from 'react';

import { AsyncSelect } from '@atlaskit/select';

import { AutoCompleteCustomOption } from '../common/ui/custom-option';
import { useAutoCompleteOptions } from '../controllers/use-auto-complete-options';

import { type AutoCompleteProps } from './types';

export const AutoComplete = <IsMulti extends boolean = false>(
	props: AutoCompleteProps<IsMulti>,
) => {
	const getAutoCompleteOptions = useAutoCompleteOptions(props.endpoints);

	return (
		<AsyncSelect
			menuPosition="absolute"
			// @ts-ignore - https://product-fabric.atlassian.net/browse/DSP-21000
			loadOptions={getAutoCompleteOptions}
			{...props}
			components={{
				Option: AutoCompleteCustomOption,
				...props.components,
			}}
		/>
	);
};
